import { Modal } from "react-bootstrap";
import { personalitiesList } from "./skeletons/PersonalitiesList";
import { useEffect, useState } from "react";
function PersonalityDetails(props) {

    const { isOpen, setShowmodal, per, handleShowPersonality } = props;

    const [onePer, setOnePer] = useState([])

    const handleShow = () => {


        setOnePer(personalitiesList.filter((x) => x.personality.trim()?.toLowerCase() === per.trim()?.toLowerCase()));
    };

    useEffect(() => {

        if (per) {
            handleShow()
        }

    }, [isOpen, per])

    return <>
        <Modal
            show={isOpen}
            onHide={() => handleShowPersonality(false, '')}
            dialogClassName="custom-modal position-relative"
            size="lg"
            centered
        >
            <div
                className="position-absolute btn btn-close"
                style={{ top: "25px", right: "20px", zIndex: "99" }}
                onClick={() => { handleShowPersonality(false, '') }}
            ></div>
            <Modal.Body>
                <div className="row">
                    {onePer.map((personality, index) => (
                        <div key={index} className="col border rounded-3 mx-2">
                            <div className="row">
                                <div className="col-12" style={{ background: "#FFE6D5" }}>
                                    <div className="row justify-content-between align-items-center mt-5">
                                        <div className="col-6">
                                            <img src={personality.img_card} alt="card-image"></img>
                                        </div>
                                        <div className="col-6">
                                            <div className="row flex-column align-items-center">
                                                <div className="col-6 d-flex justify-content-center ">
                                                    <img
                                                        width={50}
                                                        src={personality.img_letter}
                                                        alt="card-image-letter"
                                                    />
                                                </div>
                                                <div className="col-12">
                                                    <p
                                                        className="text-center"
                                                        style={{
                                                            fontSize: "48px",
                                                            fontWeight: "600",
                                                            lineHeight: "60px",
                                                        }}
                                                    >
                                                        {personality.personality}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="row justify-content-end">
                                        <div className="col-12 my-4 d-flex justify-content-start">
                                            {/* <img
                          className="me-2"
                          width={40}
                          src={personality.img_letter}
                          alt="personality-letter"
                        /> */}

                                            {/* <h2
                          className="my-auto"
                          style={{ fontSize: "25px", fontWeight: "600" }}
                        >
                          {personality.personality}
                        </h2> */}
                                        </div>
                                        <div className="col-10 mx-auto">
                                            <p style={{ fontSize: "12px" }}>{personality.text}</p>
                                            <hr />
                                        </div>
                                        <div className="col-10 mx-auto mb-5">
                                            <div className="row">
                                                <div className="col-2">
                                                    <p style={{ fontSize: "12px" }} className="">
                                                        <strong>Strengths</strong>
                                                    </p>
                                                </div>
                                                <div className="col">
                                                    <p style={{ fontSize: "12px" }}>
                                                        {personality.strengths}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-2">
                                                    <p style={{ fontSize: "12px" }} className="">
                                                        <strong>Uniqueness</strong>
                                                    </p>
                                                </div>
                                                <div className="col">
                                                    <p style={{ fontSize: "12px" }}>
                                                        {personality.uniqueness}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-2">
                                                    <p
                                                        style={{ fontSize: "12px" }}
                                                        className="text-nowrap"
                                                    >
                                                        <strong>Value to Org.</strong>
                                                    </p>
                                                </div>
                                                <div className="col">
                                                    <p style={{ fontSize: "12px" }}>
                                                        {personality.valtoorg}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-2">
                                                    <p
                                                        style={{ fontSize: "12px" }}
                                                        className="text-nowrap"
                                                    >
                                                        <strong>Challanges</strong>
                                                    </p>
                                                </div>
                                                <div className="col">
                                                    <p style={{ fontSize: "12px" }}>
                                                        {personality.challenges}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-2">
                                                    <p style={{ fontSize: "12px" }} className="">
                                                        <strong>Motivations</strong>
                                                    </p>
                                                </div>
                                                <div className="col">
                                                    <p style={{ fontSize: "12px" }}>
                                                        {personality.motivations}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Modal.Body>
            {/* <Modal.Header closeButton className="custom-close-btn">
        </Modal.Header>
      <Modal.Body>
        <div className="row">

        <div className="col p-3 border rounded-3">
                            <div className="">
                                 <div className="d-flex px-3">
                                    <h5 style={{fontSize:"20px", fontWeight:"700", lineHeight:"30px"}} className="me-2">78%</h5>
                                    <p>----------------------</p>
                                </div>
                             <div className="d-flex align-items-center ms-2" style={{cursor:"pointer"}} onClick={handleShowPersonalityCard}>
                                <img className="me-2" width={40} src={mediatorLetter}/>
                                <h2 className="mb-0" style={{fontSize:"20px", fontWeight:"700"}}>Mediator</h2>
                             </div>
                            </div>
                </div>
        </div>
      </Modal.Body> */}
        </Modal>
    </>
}

export default PersonalityDetails;